import BaseResource from './index'

export default class VoucherResource extends BaseResource {
    static endpoint = '/vouchers'

    async quoteReservationOrder(originalAmount) {
        let wrapped = this.wrap('/quote')
        let result = await wrapped.get({ params: { amount_cents: originalAmount }})
        return result.data.new_amount_cents
    }

    async getBalance() {
        const wrapped = this.wrap('/balance')
        const result = await wrapped.get()
        return result.data.balance_cents
    }

    toString() {
        return this.id
    }
}

export class UserVoucherResource extends VoucherResource {
    static endpoint = '/users/me/vouchers'

    static async purchaseGiftCard(amountCents, extras = {}) {
        const wrapped = this.wrap('/purchase')
        const postData = { amount_cents: amountCents }

        if(extras.emailTo) {
            Object.assign(postData, {
                email_to: extras.emailTo,
                email_from_name: extras.emailFromName,
                email_comments: extras.emailComments
            })
        }

        const result = await wrapped.post(postData)
        return new UserVoucherResource(result.data)
    }
}
